import React, { FC, useContext, useEffect } from 'react';
import { useState } from 'react';
import { Context } from '../../index';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import ErrorComponent from '../../components/UI/Error/ErrorComponent';
import ReCAPTCHA from 'react-google-recaptcha';
import { SPECIAL_KEY } from "../../Utils/Secret"
import stylesSapper from "../Sapper/Sapper.module.css"

import '../LoginForm/LoginForm.css';
import Spin from '../../components/UI/Spin/Spin';
import { WordsBan } from "../../Utils/WordsBan"
import vk from "./vk.png"
import google from "./google.png"
import Footer from "../../components/Footer/Footer";
import { fillTextPage } from "../../Utils/FillTextPage";
import { MODE, NAME_SERVER } from '../../Utils/NAME_HOST';
import formatCurrency from '../../Utils/formatCurrency';
function RegForm({ props }) {
    const promocode_name = props ? props.promocode : null;
    const freespins_name = props ? props.freespins : null;
    const bonus_name = props ? props.bonus_dep : null;
    const balance_bonus = props ? props.balance_bonus : null;

    const [email, setEmail] = useState('');
    const [promocode, setPromoCode] = useState(promocode_name ? promocode_name : "")
    const [password, setPassword] = useState('');
    const [login, setLogin] = useState('');
    const [error, setError] = useState("")
    const [statusErrorChange, setStatusErrorChange] = useState(false);
    const [recaptchaValue, setRecaptchaValue] = useState(null);
    const [statePassword, setStatePassword] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);

    const siteKey = "6Lda2IIqAAAAAGa_QThRv9EDl-m7H2PgzmFlyko2"; // Ваш публичный ключ

    const [token_re, setToken_re] = useState("")
    const { store } = useContext(Context);
    const navigate = useNavigate()
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const room_id = queryParams.get('room');
    const changer = (value) => {
        setToken_re(value)
    }
    useEffect(() => {
        const loadRecaptchaScript = () => {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=6Lda2IIqAAAAAGa_QThRv9EDl-m7H2PgzmFlyko2`;
            script.async = true;
            script.defer = true;

            script.onload = () => {
                console.log('reCAPTCHA script loaded successfully');
            };

            script.onerror = () => {
                console.error('Error loading reCAPTCHA script');
            };

            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        };

        loadRecaptchaScript();
        fillTextPage("register", store)

    }, []);
    useEffect(() => {

        if (error.length > 0) {
            store.add_message(error, ErrorComponent)
        }
    }, [statusErrorChange]);
    const executeRecaptcha = async (action) => {
        if (window.grecaptcha) {
            try {
                const token = await window.grecaptcha.execute(siteKey, { action });
                console.log(token)
                setCaptchaToken(token);
                return token;
            } catch (error) {
                console.log(error, "err")
                console.log("Ошибка выполнения reCAPTCHA:", error);
                return null;
            }
        }
        return null;
    };

    async function handlerButtonReg(e) {
        e.preventDefault()
        if (email && login && password) {
            try {
                const token = await executeRecaptcha('submit');

                if (!token && MODE === "prod") {
                    setError("Ошибка reCAPTCHA. Попробуйте снова.");
                    store.add_message("Ошибка reCAPTCHA. Попробуйте снова.", ErrorComponent);
                    return;
                }

                const answ_ban = WordsBan(login)
                if (true) {
                    const aswer_from_response = await store.reg(email, login, password, SPECIAL_KEY, promocode, token); // Ожидание завершения функции

                    if (aswer_from_response.err) {
                        //console.log("yes")
                        store.add_message(aswer_from_response.err, ErrorComponent)


                    } else {
                        //console.log(aswer_from_response)
                        if (aswer_from_response.modal) {
                            //console.log("set")
                            store.set_modal(aswer_from_response.modal)
                            // localStorage.setItem("modal_succses",JSON.stringify(aswer_from_response.modal))
                        }
                        if (room_id) {
                            window.location.replace("https://snake.money/game/" + room_id)
                        } else {
                            navigate("/slots")

                        }
                    }

                } else {
                    if (answ_ban === "length") {
                        setStatusErrorChange(!statusErrorChange)

                        setError("error19")

                    } else if (answ_ban === "ban_word") {
                        setStatusErrorChange(!statusErrorChange)

                        setError("error20")

                    }

                }
            }
            catch (e) {
                setStatusErrorChange(!statusErrorChange)

                setError("error1")

            }
        }
    }

    return (
        <>
            {store.isLoading ? (
                <Spin />
            ) : (
                <>
                    <div className="contentFormLogin">
                        <div className="login-box">
                            <span></span>
                            <span></span>
                            <span></span>

                            <form className="reg">

                                <h2>{store.dataLang["title_form_register"]}</h2>
                                {!balance_bonus && <input type="text" onChange={e => setLogin(e.target.value)} placeholder={store.dataLang["login_placeholder"]} />}

                                {!balance_bonus && <input type="text" onChange={e => setEmail(e.target.value)} placeholder="Email" />}


                                {!balance_bonus && <div style={{ position: "relative" }}>
                                    <input className="password" onChange={e => setPassword(e.target.value)} type={statePassword ? "text" : "password"} placeholder={store.dataLang["password_name"]} />
                                    <i style={{ top: "30px" }} class={`fa-solid ${statePassword ? "fa-eye-slash" : "fa-eye"} eye_password`} onClick={() => setStatePassword(prev => !prev)}></i>

                                </div>}
                                {promocode_name ? (
                                    <>

                                        <div className="block_inf_promocode skeleton-button">
                                            <div>После регистрации вы получите бонус</div>{freespins_name} FS + {bonus_name}% к депозиту <div> По промокоду {promocode_name}</div>
                                        </div>
                                        {balance_bonus && <div className={stylesSapper.shiny_button} style={{ padding: "10px", marginTop: "10px", cursor: "default", background: "linear-gradient(45deg, #00ff17b8, #00ffb799)", boxShadow: "0 3px 12px rgb(48 255 0 / 70%)" }}>Бонус {formatCurrency(balance_bonus, "cost")} НА РЕАЛЬНЫЙ БАЛАНС</div>}


                                    </>

                                ) : (
                                    <input type="text" onChange={e => setPromoCode(e.target.value)} placeholder={store.dataLang["inputs_payin2"]} />

                                )}

                                {!balance_bonus && <div className="button_form1 skeleton-button" onClick={handlerButtonReg} >
                                    {promocode_name ? store.dataLang["get_bonus_name"] : store.dataLang["reg_name"]}

                                </div>}

                                <div style={{ cursor: "default" }} className='forgotPassword'>{!balance_bonus ? "Вход через соцсети" : "Получите бонус, пройдя регистрацию через данные сервисы"}</div>


                                <div className="social">
                                    <a className="google" href="https://snake.money/api/auth/google/"><img src={google} width={64} height={64} /></a>
                                    <a href="https://snake.money/api/auth/vk/"><img src={vk} width={64} height={64} /></a>
                                    <a href={NAME_SERVER + "/api/auth/yandex/callback"}><img src={NAME_SERVER + "/assets/" + "icon_yandex.png"} width={64} height={64} /></a>
                                </div>

                            </form>
                        </div>
                        {/*<button><a href="https://snake.money/api/auth/google/">Google</a></button>*/}
                    </div>

                </>

            )}
        </>
    );
}

export default observer(RegForm);
